<div class="row">
  <div class="col-md-4">
    <div class="row">
      <div class="col-12 border-bottom" style="padding-bottom: 5px;">
        <div class="state mb-2 d-flex gap-1 align-items-center">
          @if (!isVideoBroken && conversation_data.video_url) {
            <button class="btn btn-danger p-1 fs-16" type="button" (click)="openDeleteVideoModal(deleteVideoModal)" ngbTooltip="Delete Video from Storage" alt="Delete Video from Storage"><i class="ri-delete-bin-line align-middle"></i></button>
          }
          @if (canvasLabels.length > 0) {
            <button class="btn btn-info p-1 flex-grow-1" type="button" disabled><span style="font-size: 16px; font-weight: 700;">{{ canvasLabel | titlecase }}</span></button>
          }
          @if (canvasLabels.length === 0) {
            <button class="btn btn-info p-1 flex-grow-1" type="button" disabled><span style="font-size: 16px; font-weight: 700;">{{ 'No Data' | titlecase }}</span></button>
          }
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <div class="camera-container ratio ratio-16x9">
            @if (!isVideoBroken && conversation_data.video_url) {
              <video crossorigin="anonymous" #videoElement controls (error)="onVideoError()"></video>
            }

            @if (isVideoBroken) {
              <div #fallbackContainer class="d-flex flex-column justify-content-center align-items-center w-100 h-100 p-4">
                <div class="text-center text-muted mt-auto">
                  <i class="ri-camera-off-line" style="font-size: 2rem;"></i>
                  <h2 class="mt-2">Video Unavailable</h2>
                  <p>Use the slider below to navigate the data.</p>
                </div>
                <div class="w-100 d-flex align-items-center mt-auto">
                  <span class="me-2">{{ currentTime * 1000 | date:'mm:ss' }}</span>
                  <input type="range" class="form-range flex-grow-1" [min]="0" [max]="totalDuration" [value]="currentTime" (input)="onManualTimeChange($event)">
                  <span class="ms-2">{{ totalDuration * 1000 | date:'mm:ss' }}</span>
                </div>
              </div>
            }

          </div>
        </div>
      </div>
      <div class="col-12 mt-4">
        @if (!polar_chart_show) {
          <div class="text-center mt-sm-5 pt-4 mb-4">
            <h4>
              <p class="text-muted">Data analyze incomplete.</p>
              <p class="text-muted">Certain factors prevented to extract the data.</p>
            </h4>
          </div>
        }
        @if (polar_chart_show) {
          <app-conv-polar-chart #convPolarChart [rgbData]="conversation_data.rgbData" [blinksData]="conversation_data.blinksData" [heatmap_leaks]="conversation_data.heatmap_leaks" [heatmap_leaks_max_value]="conversation_data.heatmap_leaks_max_value" [polar_intensity]="conversation_data.polar_intensity" [polar_pulse]="conversation_data.polar_pulse" (reloadData)="polarChartWindowTime()"></app-conv-polar-chart>
        }
      </div>
    </div>
  </div>
  <div class="col-md-8">
    <div class="row">
      <div class="col-12 pb-2 border-bottom" style="max-height: 347px; min-height: 347px;">
        <ul ngbNav #Border="ngbNav" [activeId]="activeId" (navChange)="changeTab($event)" class="nav nav-tabs nav-border-top nav-border-top-info">
          <li [ngbNavItem]="1">
            <a ngbNavLink> General </a>
            <ng-template ngbNavContent>
              <app-conv-heatmap-chart #convHeatmapChart [patternGlobalData]="conversation_data.templates_heatmap_arr_all" [globalData]="conversation_data.global_heatmap" [rgbData]="conversation_data.rgbData" [leaksData]="conversation_data.leaksData" [blinksData]="conversation_data.blinksData" [voiceHeatMapData]="conversation_data.voiceHeatMapData"></app-conv-heatmap-chart>
            </ng-template>
          </li>
          <li [ngbNavItem]="2" [disabled]="!voice_chart_show">
            <a ngbNavLink> Voice </a>
            <ng-template ngbNavContent>
              <app-conv-voice-chart #convVoiceChart [voiceData]="conversation_data.voiceData" [voicePitchData]="conversation_data.voicePitchData" [voiceSegmentData]="conversation_data.voiceSegmentData"></app-conv-voice-chart>
            </ng-template>
          </li>
          <li [ngbNavItem]="3" [disabled]="!leaks_chart_show">
            <a ngbNavLink> Leaks </a>
            <ng-template ngbNavContent>
              <app-conv-leaks-chart #convLeaksChart [heatmap_leaks]="conversation_data.heatmap_leaks" [heatmap_leaks_max_value]="conversation_data.heatmap_leaks_max_value"></app-conv-leaks-chart>
            </ng-template>
          </li>
          <li [ngbNavItem]="4" [disabled]="!blinks_chart_show">
            <a ngbNavLink> Engagment </a>
            <ng-template ngbNavContent>
              <app-conv-blinks-chart #convBlinksChart [url_service]="url_service.smoothedRGBResults" [blinksData]="conversation_data.blinksData" [smoothedCog]="conversation_data.smoothed_rgb.smoothed_cog" [smoothedEmo]="conversation_data.smoothed_rgb.smoothed_emo"></app-conv-blinks-chart>
            </ng-template>
          </li>
          <li [ngbNavItem]="5" [disabled]="!feelings_chart_show">
            <a ngbNavLink> Feelings </a>
            <ng-template ngbNavContent>
              <app-conv-emotion-chart #convEmotionChart [emotionData]="conversation_data.emotionData"></app-conv-emotion-chart>
            </ng-template>
          </li>
          <li [ngbNavItem]="6" [disabled]="!q_heatmap_chart_show">
            <a ngbNavLink> Correlation </a>
            <ng-template ngbNavContent>
              <app-conv-q-heatmap-chart #convQHeatmapChart [data]="resultsWithTimeline" [series]="qna_series" [default_series]="qna_default_series"></app-conv-q-heatmap-chart>
            </ng-template>
          </li>
          <li [ngbNavItem]="7" [disabled]="!q_heatmap_chart_show">
            <a ngbNavLink> Reports </a>
            <ng-template ngbNavContent>
              <app-report-generation [allReports]="conversation.extra_content.reports || []" [entity]="conversation" [autoOpenReportId]="targetReportId" (reportOpened)="reportOpened.emit()" [page_source]="page_source" [page_data]="page_data" (updateReportsEvent)="updateConversation($event)"></app-report-generation>
            </ng-template>
          </li>
          @if (allowSpecial) {
            <li [ngbNavItem]="8" [disabled]="!skin_chart_show">
              <a ngbNavLink> Skin </a>
              <ng-template ngbNavContent>
                <app-conv-rgb-chart #convSkinChart [rgbData]="conversation_data.rgbData"></app-conv-rgb-chart>
              </ng-template>
            </li>
          }
          @if (allowSpecial && leaks_extended_show) {
            <li [ngbNavItem]="9">
              <a ngbNavLink class="p-0 m-0 ms-1 border-0">
                <ng-select class="leaksExtended" [items]="categories" bindLabel="label" [searchable]="false" [clearable]="false" [(ngModel)]="selectedCategory" (ngModelChange)="onCategoryChange()"></ng-select>
              </a>
              <ng-template ngbNavContent>
                <app-conv-leaks-extended #convLeaksExtended [fullTimeline]="conversation_data.get_leaks_long_short" [activeCategory]="selectedCategory.value"></app-conv-leaks-extended>
              </ng-template>
            </li>
          }
          @if (allowSpecial && new_leaks_chart_show) {
            <li [ngbNavItem]="10">
              <a ngbNavLink class="p-0 m-0 ms-1 border-0"> <ng-select [items]="face_areas" bindLabel="label" [searchable]="false" [clearable]="false" [(ngModel)]="selectedFaceArea" (ngModelChange)="onFaceAreaChange()"></ng-select></a>
              <ng-template ngbNavContent>
                @if (selectedFaceArea.value === 'head') {
                  <app-conv-hneb-chart #convHeadPosition [head_positions]="conversation_data.head_positions" [area_type]="'head'"></app-conv-hneb-chart>
                }
                @if (selectedFaceArea.value === 'blinks') {
                  <app-conv-blinks-heatmap #convBlinksHeatmap [data]="conversation_data.blink_analysis_list"></app-conv-blinks-heatmap>
                }
                @if (selectedFaceArea.value === 'squints') {
                  <app-conv-squint-heatmap #convSquintHeatmap [data]="conversation_data.squint_analysis_list"></app-conv-squint-heatmap>
                }
              </ng-template>
            </li>
          }
          @if (allowSpecial) {
            <li [ngbNavItem]="13">
              <a ngbNavLink> New LLM </a>
              <ng-template ngbNavContent>
                @if (!isVersionOutdated) {
                  <app-conv-vertexai-chat [url_service]="url_service"></app-conv-vertexai-chat>
                }
                @if (isVersionOutdated) {
                  <div class="text-center">
                    <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
                    <h4 class="mb-3 mt-4">The video is analyzed with old version, you must re-analyze this video for generating report.</h4>
                    <p class="text-muted mb-4">You must re-analyze this video to use the New LLM features.</p>
                    <button type="button" class="btn btn-primary btn-load" [disabled]="spinner" (click)="reanalyzeSubmit()">
                      <span class="d-flex justify-content-center">
                        @if (submitted && spinner) {
                          <span class="spinner-border spinner-border-sm" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </span>
                        }
                        <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Re-Analyze {{ 'conversation' | titlecase }}</span>
                      </span>
                    </button>
                  </div>
                }
              </ng-template>
            </li>
          }
        </ul>
        <div class="tab-content text-muted">
          <div [ngbNavOutlet]="Border"></div>
        </div>
      </div>
      <div class="col-12">
        <app-conv-chat-bot #convChatBot [url_service]="url_service" (jumpToTime)="onJumpToTime($event)"></app-conv-chat-bot>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteVideoModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>

        <div class="alert alert-danger">
          <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
        </div>

        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Delete Video Source File?</h4>
          <p class="text-start text-muted mt-2 mb-0">
            You are about to permanently remove this MP4 file from storage.<br />
            This cannot be reversed, and you will not be able to re-upload it to this current conversation.<br />
            To upload this video again, you will need to create a new conversation.
          </p>
        </div>
      </div>

      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
        <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteVideo()" [disabled]="submitted && spinner">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #responseModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        }
        <h4 class="mb-3 mt-4">{{ message }}</h4>
      </div>
    </div>
  </div>
</ng-template>

<app-generate-new-report #generateNewReport [page_source]="page_source" [page_data]="page_data" (updateReportsEvent)="updateReports($event)"></app-generate-new-report>